import { createContext, useContext, useRef } from "react";

const PopupContainerContext = createContext<any>({} as any);

function PopupContainerProvider({ children }) {
  const ref = useRef();
  return (
    <PopupContainerContext.Provider value={ref}>
      {children}
    </PopupContainerContext.Provider>
  );
}

export function usePopupContainer() {
  return useContext(PopupContainerContext);
}

export default PopupContainerProvider;
